import React from "react";
import { Routes, Route } from "react-router-dom";
import { AcademicsPage } from "components/pages/AcademicsPage";
import AcademicGraduationChecklistPage from "components/pages/AcademicGraduationChecklistPage";

import AcademicClassPage from "../pages/AcademicClassPage";
import { AcademicSummaryPage } from "../pages/AcademicSummaryPage";
import { SemesterPage } from "../pages/SemesterPage";
import { BookListPage } from "../pages/BookListPage";
import { TeachingCoursePage } from "../pages/TeachingCoursePage";
import { ExamResultsPage } from "../pages/ExamResultsPage";
import { EnrollmentVerificationPage } from "../pages/EnrollmentVerificationPage";

export default function AcademicsRoutes() {
  return (
    <Routes>
      <Route path="" element={<AcademicsPage />} />
      <Route path="academic_summary" element={<AcademicSummaryPage />} />
      <Route path="booklist/:semesterId" element={<BookListPage />} />
      <Route
        path="enrollment_verification"
        element={<EnrollmentVerificationPage />}
      />
      <Route path="exam_results" element={<ExamResultsPage />} />
      <Route
        path="graduation_checklist"
        element={<AcademicGraduationChecklistPage />}
      />
      <Route path="semester/:semesterId" element={<SemesterPage />} />
      <Route
        path="semester/:semesterId/class/:classId"
        element={<AcademicClassPage />}
      />
      <Route
        path="semester/:semesterId/class/:classId/:sectionSlug"
        element={<AcademicClassPage />}
      />
      <Route
        path="teaching-semester/:semesterId/class/:classId/*"
        element={<TeachingCoursePage />}
      />
    </Routes>
  );
}
